import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { UPDATE_USER_GROUP_RESOURCE, USER_GROUPS_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const UpdateUserGroupService = ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_USER_GROUP_RESOURCE,
      method: 'put',
      request: (organisationId, userGroupId, body, callback, rejectCallback, t) => ({
        url: apiRoutes.userGroups(organisationId, userGroupId),
        body,
        meta: {
          callback,
          rejectCallback,
          updateOtherList: {
            resource: USER_GROUPS_RESOURCE,
            idProp: 'id',
            id: userGroupId,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'updateUserGroupFailed'),
            onSuccessMessage: t('updateUserGroupSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default UpdateUserGroupService;
